import { Close } from "@mui/icons-material";
import { Dialog, DialogContent, IconButton, Toolbar, Typography } from "@mui/material";
import MatchedAmountTable from "../../../Reconciliation/Tabs/DSCards/ReconciliationDialog/MatchedAmountTable";

const MerchantDetailsDialog = ({ open, onClose, data }) => {
    // console.log("dataaaaaaaaaaaaaaaaaaaa",data)

    // const dummyData = [
    //     {
    //         sale_date: "2025-09-01",
    //         card_type: "Visa",
    //         amount: 250.75,
    //         transactions: [
    //             {
    //                 settlement_date: "2025-09-02",
    //                 gross_amount: "$250.75",
    //                 chargebacks: "$0.00",
    //                 financial_adjustments: "$-5.00",
    //                 net_amount: "$245.75",
    //                 openDifference: "$0.00",
    //             },
    //             {
    //                 settlement_date: "2025-09-02",
    //                 gross_amount: "$250.75",
    //                 chargebacks: "$0.00",
    //                 financial_adjustments: "$-5.00",
    //                 net_amount: "$245.75",
    //                 openDifference: "$0.00",
    //             },
    //             {
    //                 settlement_date: "2025-09-02",
    //                 gross_amount: "$250.75",
    //                 chargebacks: "$0.00",
    //                 financial_adjustments: "$-5.00",
    //                 net_amount: "$245.75",
    //                 openDifference: "$0.00",
    //             },
    //         ],
    //     },
    //     {
    //         sale_date: "2025-09-03",
    //         card_type: "Mastercard",
    //         amount: 180.40,
    //         transactions: [
    //             {
    //                 settlement_date: "2025-09-04",
    //                 gross_amount: "$180.40",
    //                 chargebacks: "$15.00",
    //                 financial_adjustments: "$-3.00",
    //                 net_amount: "$162.40",
    //                 openDifference: "$15.00",
    //             },
    //             {
    //                 settlement_date: "2025-09-04",
    //                 gross_amount: "$180.40",
    //                 chargebacks: "$15.00",
    //                 financial_adjustments: "$-3.00",
    //                 net_amount: "$162.40",
    //                 openDifference: "$15.00",
    //             },
    //         ],
    //     },
    //     {
    //         sale_date: "2025-09-05",
    //         card_type: "Amex",
    //         amount: 320.90,
    //         transactions: [
    //             {
    //                 settlement_date: "2025-09-06",
    //                 gross_amount: "$320.90",
    //                 chargebacks: "$10.00",
    //                 financial_adjustments: "$-6.00",
    //                 net_amount: "$304.90",
    //                 openDifference: "$10.00",
    //             },
    //             {
    //                 settlement_date: "2025-09-06",
    //                 gross_amount: "$320.90",
    //                 chargebacks: "$10.00",
    //                 financial_adjustments: "$-6.00",
    //                 net_amount: "$304.90",
    //                 openDifference: "$10.00",
    //             },
    //             {
    //                 settlement_date: "2025-09-06",
    //                 gross_amount: "$320.90",
    //                 chargebacks: "$10.00",
    //                 financial_adjustments: "$-6.00",
    //                 net_amount: "$304.90",
    //                 openDifference: "$10.00",
    //             },
    //             {
    //                 settlement_date: "2025-09-06",
    //                 gross_amount: "$320.90",
    //                 chargebacks: "$10.00",
    //                 financial_adjustments: "$-6.00",
    //                 net_amount: "$304.90",
    //                 openDifference: "$10.00",
    //             },
    //         ],
    //     },
    // ];


    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="xl"

        >
            <Toolbar sx={{ bgcolor: "#d7d7d7" }}>
            
                <Typography
                    sx={{
                        // ml: 2,
                        flex: 1,
                        color: "#1f1f1f",
                    }}
                    component="div"
                    fontWeight={600}
                    fontSize={"16px"}
                >
                    {/* Matched details for 08/20/2025 */}
                      Matched details for {data[0]?.transactions[0]?.settlement_date}
                </Typography>
                    <IconButton
                    size="small"
                    edge="start"
                    onClick={onClose}
                    style={{ backgroundColor: "#686868", borderRadius: "50" }}
                    disableRipple
                >
                    <Close sx={{ color: "white" }} />
                </IconButton>
            </Toolbar>

            <DialogContent sx={{ padding: 1 }}>
                <MatchedAmountTable data={data} />

            </DialogContent>

        </Dialog>
    );
};

export default MerchantDetailsDialog;